import axios, { AxiosInstance } from "axios";

class ProtheusProvider {
  public axiosInstance: AxiosInstance;

  public urls = {
    hml: 'https://protheusaion.ethosx.com.br:9335/rest',
    prod: 'https://protheusaion.ethosx.com.br:7421/rest',
  }

  public url = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? this.urls.hml : this.urls.prod

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: this.url,
      headers: {
        'Accept-Language': 'pt-BR',
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }
}

export default new ProtheusProvider().axiosInstance;

